import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 実力テスト教科別成績取得（Tコース）
 */
export namespace ApiTaRe030 {
  // API Name
  export const name: string = 'ApiTaRe030'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/testSubjectRecord'

    export interface Request {
      query: {
        subjectCode: string
        fiscalYear: number
        month: number
        times?: number
        grade: number
      }
    }

    export interface Response {
      resultsBySubject: {
        memNum: string
        results: {
          questionNo: string
          subQuestionNo: string
          categoryName: string
          difficultyLevel: string
          allocation: string
          score: string
          average: string
          perfectScoreRate: string
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        resultsBySubject: {
          memNum: '',
          results: [
            {
              questionNo: '',
              subQuestionNo: '',
              categoryName: '',
              difficultyLevel: '',
              allocation: '',
              score: '',
              average: '',
              perfectScoreRate: '',
            },
          ],
        },
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
